// Panel width constraints
export const PANEL_CONSTANTS = {
    // Left panel (typically used for navigation/tree view)
    LEFT_PANEL: {
        MIN_WIDTH: 150,
        MAX_WIDTH: 300,
        DEFAULT_WIDTH: 150
    },
    // Right panel (typically used for properties/details)
    RIGHT_PANEL: {
        MIN_WIDTH: 200,
        MAX_WIDTH: 1200,
        DEFAULT_WIDTH: 300
    }
} as const;
